"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIG = void 0;
exports.CONFIG = {
    BLUE_01: {
        backgroundColor: 'WARM_BLUE_30',
        gradientColor: 'WARM_BLUE_60',
        patternStyle: 'grid',
        patternDensity: 'tight',
        patternColor: 'WARM_BLUE_60',
        shapesVersion: 'BLUE_01',
    },
    BLUE_02: {
        backgroundColor: 'PALE_BLUE_40',
        gradientColor: 'BLUE_40',
        patternStyle: 'grid',
        patternDensity: 'normal',
        patternColor: 'BLUE_40',
        shapesVersion: 'BLUE_02',
    },
    BLUE_03: {
        backgroundColor: 'BLUE_30',
        gradientColor: 'BLUE_50',
        patternStyle: 'lines-horizontal',
        patternDensity: 'tight',
        patternColor: 'BLUE_40',
        shapesVersion: 'BLUE_03',
    },
    BLUE_LIGHT_01: {
        backgroundColor: 'WARM_BLUE_30',
        gradientColor: 'BLUE_40',
        patternStyle: 'grid',
        patternDensity: 'tight',
        patternColor: 'WARM_BLUE_60',
        shapesVersion: 'BLUE_01',
    },
    BLUE_LIGHT_02: {
        backgroundColor: 'PALE_BLUE_50',
        gradientColor: 'BLUE_40',
        patternStyle: 'grid',
        patternDensity: 'normal',
        patternColor: 'BLUE_40',
        shapesVersion: 'BLUE_02',
    },
    GREEN_01: {
        backgroundColor: 'GREEN_30',
        gradientColor: 'GREEN_50',
        patternStyle: 'grid',
        patternDensity: 'tight',
        patternColor: 'GREEN_60',
        shapesVersion: 'GREEN_01',
    },
    GREEN_02: {
        backgroundColor: 'GREEN_30',
        gradientColor: 'GREEN_50',
        patternStyle: 'dots',
        patternDensity: 'tight',
        patternColor: 'GREEN_60',
        shapesVersion: 'GREEN_02',
    },
    GREEN_03: {
        backgroundColor: 'GREEN_30',
        gradientColor: 'BLUE_40',
        patternStyle: 'grid',
        patternDensity: 'normal',
        patternColor: 'BLUE_50',
        shapesVersion: 'GREEN_03',
    },
    GREEN_LIGHT_01: {
        backgroundColor: 'GREEN_30',
        gradientColor: 'GREEN_50',
        patternStyle: 'lines-diagonal',
        patternDensity: 'tight',
        patternColor: 'GREEN_40',
        shapesVersion: 'GREEN_01',
    },
    GREEN_LIGHT_02: {
        backgroundColor: 'GREEN_30',
        gradientColor: 'GREEN_50',
        patternStyle: 'dots',
        patternDensity: 'tight',
        patternColor: 'GREEN_45',
        shapesVersion: 'GREEN_02',
    },
    RED_01: {
        backgroundColor: 'RED_30',
        gradientColor: 'RED_50',
        patternStyle: 'lines-diagonal',
        patternDensity: 'normal',
        patternColor: 'RED_50',
        shapesVersion: 'RED_01',
    },
    RED_02: {
        backgroundColor: 'RED_20',
        gradientColor: 'YELLOW_30',
        patternStyle: 'dots',
        patternDensity: 'tight',
        patternColor: 'PINK_20',
        shapesVersion: 'RED_02',
    },
    RED_03: {
        backgroundColor: 'RED_30',
        gradientColor: 'PINK_20',
        patternStyle: 'grid',
        patternDensity: 'tight',
        patternColor: 'RED_60',
        shapesVersion: 'RED_03',
    },
    PINK_01: {
        backgroundColor: 'PINK_30',
        gradientColor: 'RED_40',
        patternStyle: 'dots',
        patternDensity: 'tight',
        patternColor: 'RED_40',
        shapesVersion: 'PINK_01',
    },
    PINK_02: {
        backgroundColor: 'PINK_20',
        gradientColor: 'RED_40',
        patternStyle: 'lines-horizontal',
        patternDensity: 'tight',
        patternColor: 'RED_40',
        shapesVersion: 'PINK_02',
    },
    PINK_03: {
        backgroundColor: 'PINK_30',
        gradientColor: 'YELLOW_20',
        patternStyle: 'lines-diagonal',
        patternDensity: 'tight',
        patternColor: 'PINK_60',
        shapesVersion: 'PINK_03',
    },
    PINK_LIGHT_01: {
        backgroundColor: 'PINK_30',
        gradientColor: 'RED_40',
        patternStyle: 'dots',
        patternDensity: 'tight',
        patternColor: 'PINK_50',
        shapesVersion: 'PINK_01',
    },
    PINK_LIGHT_02: {
        backgroundColor: 'PINK_20',
        gradientColor: 'RED_40',
        patternStyle: 'lines-horizontal',
        patternDensity: 'tight',
        patternColor: 'PINK_50',
        shapesVersion: 'PINK_02',
    },
    YELLOW_01: {
        backgroundColor: 'YELLOW_20',
        gradientColor: 'YELLOW_60',
        patternStyle: 'dots',
        patternDensity: 'tight',
        patternColor: 'YELLOW_50',
        shapesVersion: 'YELLOW_01',
    },
    YELLOW_02: {
        backgroundColor: 'YELLOW_30',
        gradientColor: 'YELLOW_30',
        patternStyle: 'grid',
        patternDensity: 'normal',
        patternColor: 'BLUE_50',
        shapesVersion: 'YELLOW_02',
    },
    YELLOW_03: {
        backgroundColor: 'YELLOW_30',
        gradientColor: 'YELLOW_30',
        patternStyle: 'dots',
        patternDensity: 'tight',
        patternColor: 'YELLOW_50',
        shapesVersion: 'YELLOW_03',
    },
    YELLOW_LIGHT_01: {
        backgroundColor: 'YELLOW_20',
        gradientColor: 'YELLOW_60',
        patternStyle: 'dots',
        patternDensity: 'tight',
        patternColor: 'YELLOW_50',
        shapesVersion: 'YELLOW_01',
    },
    YELLOW_LIGHT_02: {
        backgroundColor: 'YELLOW_30',
        gradientColor: 'YELLOW_30',
        patternStyle: 'grid',
        patternDensity: 'normal',
        patternColor: 'YELLOW_60',
        shapesVersion: 'YELLOW_02',
    },
};
